import React from "react";
import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";
import Section8 from "./Section8";
import Section9 from "./Section9";
import Section10 from "./Section10";


export default function WebNewYorkPage() {
    return (
        <div className="Ui-And-Ux-Design pt-[160px] sm:pt-0">
            <Helmet>
                <title>Top Web Development Agency in New York | NYC Web Development Services</title>
                <meta
                    name="description"
                    content="Mean3 is a trusted web development company in New York, serving 300+ clients with Shopify, Magento, React & Laravel solutions. Get a free consultation today."
                />
            </Helmet>
            <Section1 />
            <div className="bg-gray-100">
                <Section2 />
                <Section3 />
                <Section4 />
                <Section5 />
                <Section6 />
                {/* <Section7 /> */}
                <Section8 />
                <Section9 />
                <Section10 />
            </div>

        </div>
    );
}

